import { Pipe, PipeTransform } from '@angular/core';
import { FamilyTreeService } from '../services/family-tree.service';
import { CommonService } from 'src/app/common/services/common.service';

@Pipe({
    name: 'displayProfilePic'
})
export class DisplayProfilePicPipe implements PipeTransform {

    public profilePicture: string;

    constructor(private familyTreeService: FamilyTreeService,
        private commonService: CommonService) { }

    transform(member: any): string {
        if (member?.pictureUniqueId) {
            this.profilePicture = this.familyTreeService.getFamilyTreeNodePicture(member?.id);
        } else {
            const fullName = member?.displayName ?? member?.firstName + ' ' + member?.lastName;
            this.profilePicture = this.commonService.generateUserInitials(fullName);
        }
        return this.profilePicture;
    }

}
